module.exports = __webpack_public_path__ + "img/tarj1-3.ac229620.png";